"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
exports.default = (function (virtual) { return function (data) {
    var fields = virtual.protocol.fields;
    var cmds = virtual.protocol.cmds;
    if (!data.cmdId) {
        return data;
    }
    var cmd = cmds[data.cmdId];
    if (!cmd) {
        return data;
    }
    return cmd.fields.reduce(function (val, field) {
        if (fields[field].dataType === 'STRING') {
            val[field] = data[field] !== undefined && data[field] !== null ? data[field] : '';
        }
        else {
            val[field] =
                data[field] !== undefined && data[field] !== null
                    ? utils_1.getCorrectVal(data[field], fields[field])
                    : utils_1.getValFromProtocol(fields[field]);
        }
        return val;
    }, { cmdId: cmd.cmdId });
}; });



// WEBPACK FOOTER //
// ./src/decode/jsonCtrl.ts